import { PropertyTypeQuestion } from '@hb/domain';
import { PropertyTypeStoreService } from '@hb/modules/property/property-type/property-type-store.service';
import { PropertyTypeButtonComponent } from '@hb/modules/property/property-type/property-type-button/property-type-button.component';
import { PreviousButtonComponent } from '@hb/modules/global/button';

import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApContentModule } from '@ap/content';
import { ApRadioModule } from '@ap/radio';

@Component({
    selector: 'property-type',
    templateUrl: './property-type.component.html',
    standalone: true,
    imports: [ApContentModule, FormsModule, ReactiveFormsModule, ApRadioModule, PreviousButtonComponent, PropertyTypeButtonComponent]
})
export class PropertyTypeComponent implements OnInit, OnDestroy {
    protected readonly store = inject(PropertyTypeStoreService);

    private activeQuestion: PropertyTypeQuestion;
    private activeQuestionSubscription: Subscription;

    ngOnInit(): void {
        this.activeQuestionSubscription = this.store
            .getActiveQuestion()
            .subscribe((activeQuestion) => (this.activeQuestion = activeQuestion));
    }

    ngOnDestroy(): void {
        this.activeQuestionSubscription.unsubscribe();
    }

    previousQuestion(): void {
        this.store.backQuestion();
    }

    showPropertyType(): boolean {
        return (
            this.activeQuestion === PropertyTypeQuestion.PROPERTY_TYPE_BUTTON ||
            (this.store.isActiveQuestion(PropertyTypeQuestion.PROPERTY_TYPE_BUTTON) && this.store.isSummary)
        );
    }
}
